import { render, staticRenderFns } from "./SantaSpinner.vue?vue&type=template&id=01712304&scoped=true&"
import script from "./SantaSpinner.vue?vue&type=script&lang=ts&"
export * from "./SantaSpinner.vue?vue&type=script&lang=ts&"
import style0 from "./SantaSpinner.vue?vue&type=style&index=0&id=01712304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01712304",
  null
  
)

export default component.exports